import { EntityAttributeDetailDto } from '@/api/backoffice/clients';
import { object, array, number } from 'yup';

export const useProductEntityDataMappingValidations = (t) => {
    const validationSchema = object({
        fromEntity: object()
            .nullable()
            .required(t('validations.messages.required', { _field_: t('productEntityDataMapping.detail.fromEntity') })),
        toEntity: object()
            .nullable()
            .required(t('validations.messages.required', { _field_: t('productEntityDataMapping.detail.toEntity') })),
        attributeMappings: array()
            .nullable()
            .of(
                object().shape({
                    id: number().optional().nullable(),
                    from: object()
                        .required(
                            t('validations.messages.required', {
                                _field_: t('productEntityDataMapping.detail.fromAttribute')
                            })
                        )
                        .test(
                            'dataType-match',
                            t('validations.messages.matchPrerequisites', {
                                _field_: t('productEntityDataMapping.detail.attributeMapping')
                            }),
                            checkEntityAttributesDataType({ testTo: true })
                        ),
                    to: object()
                        .required(
                            t('validations.messages.required', {
                                _field_: t('productEntityDataMapping.detail.toAttribute')
                            })
                        )
                        .test(
                            'dataType-match',
                            t('validations.messages.matchPrerequisites', {
                                _field_: t('productEntityDataMapping.detail.attributeMapping')
                            }),
                            checkEntityAttributesDataType({ testFrom: true })
                        )
                })
            )
            .required(t('productEntityDataMapping.detail.attributeMappingsRequired'))
            .min(1, t('productEntityDataMapping.detail.attributeMappingsRequired'))
    });

    return {
        validationSchema
    };
};

function checkEntityAttributesDataType({ testFrom, testTo }: { testFrom?: boolean; testTo?: boolean }) {
    const testFunction = (value, ctx) => {
        if (testFrom) {
            const { from } = ctx.parent;
            const to = value as EntityAttributeDetailDto;
            return !from || !to || isDataTypeValid(from, to);
        }
        if (testTo) {
            const { to } = ctx.parent;
            const from = value as EntityAttributeDetailDto;
            return !from || !to || isDataTypeValid(from, to);
        }
        return true;
    };
    return testFunction;
}

function isDataTypeValid(from: EntityAttributeDetailDto, to: EntityAttributeDetailDto) {
    if (!from.dataType || !to.dataType || from.dataType.id !== to.dataType.id) {
        return false;
    }

    if (to.length < from.length) {
        return false;
    }

    return true;
}
